// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2bPvW","label":"CategoryService_label__2eVB-","location":"CategoryService_location__1wO7S"};